"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogDocumentValueFormatter = void 0;
var bignumber_1 = require("@ethersproject/bignumber");
var LogDocumentValueFormatter = /** @class */ (function () {
    function LogDocumentValueFormatter() {
    }
    LogDocumentValueFormatter.format = function (param) {
        switch (param.type) {
            case 'string':
                return param.value;
            case 'address':
                return param.value.toLowerCase();
            default:
                if (bignumber_1.BigNumber.isBigNumber(param.value)) {
                    return param.value.toString();
                }
                return param.value.toString();
        }
    };
    return LogDocumentValueFormatter;
}());
exports.LogDocumentValueFormatter = LogDocumentValueFormatter;
//# sourceMappingURL=LogDocumentValueFormatter.js.map